import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-informacoes-uteis',
  templateUrl: './informacoes-uteis.component.html',
  styleUrls: ['./informacoes-uteis.component.scss']
})
export class InformacoesUteisComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
